// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
}

.search-container {
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 48%;
  flex-grow: 1;
  gap: 8px;
}

#search_input {
  height: 28px;
  width: 52%;
}

.content {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  width: 95%;
  gap: 8px;
}

.text {
  padding: 10px;
  flex-grow: 1;
  border: 1px solid #000;
  white-space: pre-wrap;
  font-size: 16px;
  padding: 32px 32px 32px 16px;
}

.text > h2 {
  text-align: left;
  text-decoration: none;
}

#original {
  margin-top: 8px;
}

#filtered {
  margin-top: 8px;
}

.dropdown {
  width: 45%;
  height: 28px;
}

.input-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.text {
  width: 48%;
  padding: 10px;
  border: 1px solid #000;
  border-radius: 10px;
  white-space: pre-wrap;
  font-size: 16px;
  padding: 32px 32px 32px 16px;
}

#conversation {
  margin-top: 8px;
}

.buttons-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  gap: 8px;
}

.debug-switch {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.select-container {
  display: flex;
  padding: 10px;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  flex-grow: 1;
  width: 80%;
  gap: 6px;
}

.session-id-container {
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 48%;
  flex-grow: 1;
  gap: 8px;
}

.session-id-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.search-select-container {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  width: 95%;
}

.select-switch {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
}

.heading {
  text-align: left;
}

.clear-button {
  cursor: pointer;
  background-color: red;
  color: white;
  padding: 8px 13px;
}

.select-options {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.switch-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    margin: 0;
  }
}

.user-details-manual {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.expander-container {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 8px;
}

.expander-header {
  width: 100%;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  transition: background-color 0.2s ease;
}

.expander-header:hover {
  background-color: #e9e9e9;
}

.expand-icon {
  font-size: 12px;
  transition: transform 0.2s ease;
}

.ltm-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ltm-entry {
  padding: 5px 0 5px 0;
  margin: 0 20px 0 20px;
  border-bottom: 1px solid #d0d0d0;
}

.ltm-field {
  margin-bottom: 5px;
  display: flex;
  gap: 5px;
}

.ltm-tag {
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.searchable-dropdown {
  min-width: 400px;
}

.searchable-dropdown-input .MuiOutlinedInput-root {
  height: 32px;
  font-size: 14px;
}

.MuiAutocomplete-popper .MuiAutocomplete-listbox {
  max-height: 600px;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Components/users/users.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB;IACE,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".users-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 25px;\n}\n\n.search-container {\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 48%;\n  flex-grow: 1;\n  gap: 8px;\n}\n\n#search_input {\n  height: 28px;\n  width: 52%;\n}\n\n.content {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 16px;\n  width: 95%;\n  gap: 8px;\n}\n\n.text {\n  padding: 10px;\n  flex-grow: 1;\n  border: 1px solid #000;\n  white-space: pre-wrap;\n  font-size: 16px;\n  padding: 32px 32px 32px 16px;\n}\n\n.text > h2 {\n  text-align: left;\n  text-decoration: none;\n}\n\n#original {\n  margin-top: 8px;\n}\n\n#filtered {\n  margin-top: 8px;\n}\n\n.dropdown {\n  width: 45%;\n  height: 28px;\n}\n\n.input-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.text {\n  width: 48%;\n  padding: 10px;\n  border: 1px solid #000;\n  border-radius: 10px;\n  white-space: pre-wrap;\n  font-size: 16px;\n  padding: 32px 32px 32px 16px;\n}\n\n#conversation {\n  margin-top: 8px;\n}\n\n.buttons-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 8px;\n  gap: 8px;\n}\n\n.debug-switch {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.select-container {\n  display: flex;\n  padding: 10px;\n  flex-direction: column;\n  justify-content: start;\n  align-items: center;\n  flex-grow: 1;\n  width: 80%;\n  gap: 6px;\n}\n\n.session-id-container {\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 48%;\n  flex-grow: 1;\n  gap: 8px;\n}\n\n.session-id-buttons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.search-select-container {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  width: 95%;\n}\n\n.select-switch {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n}\n\n.heading {\n  text-align: left;\n}\n\n.clear-button {\n  cursor: pointer;\n  background-color: red;\n  color: white;\n  padding: 8px 13px;\n}\n\n.select-options {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.switch-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  p {\n    margin: 0;\n  }\n}\n\n.user-details-manual {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n}\n\n.expander-container {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-top: 8px;\n}\n\n.expander-header {\n  width: 100%;\n  padding: 12px 16px;\n  background-color: #f5f5f5;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 600;\n  font-size: 16px;\n  transition: background-color 0.2s ease;\n}\n\n.expander-header:hover {\n  background-color: #e9e9e9;\n}\n\n.expand-icon {\n  font-size: 12px;\n  transition: transform 0.2s ease;\n}\n\n.ltm-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ltm-entry {\n  padding: 5px 0 5px 0;\n  margin: 0 20px 0 20px;\n  border-bottom: 1px solid #d0d0d0;\n}\n\n.ltm-field {\n  margin-bottom: 5px;\n  display: flex;\n  gap: 5px;\n}\n\n.ltm-tag {\n  background-color: #e3f2fd;\n  color: #1976d2;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.searchable-dropdown {\n  min-width: 400px;\n}\n\n.searchable-dropdown-input .MuiOutlinedInput-root {\n  height: 32px;\n  font-size: 14px;\n}\n\n.MuiAutocomplete-popper .MuiAutocomplete-listbox {\n  max-height: 600px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
